import api from '../api';

// Helper function để tạo headers với token
const getAuthHeaders = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

// Order API functions for admin
export const adminOrderApi = {
  // Lấy danh sách tất cả orders
  getOrders: async (token, params = {}) => {
    try {
      const url = '/orders';
      const response = await api.get(url, {
        headers: getAuthHeaders(token),
        params
      });
      return response;
    } catch (error) {
      console.error('Error getting orders:', error);
      throw error;
    }
  },

  // Lấy orders với date range
  getOrdersWithDateRange: async (token, apiUrl) => {
    try {
      const response = await api.get(apiUrl, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting orders with date range:', error);
      throw error;
    }
  },

  // Lấy chi tiết order theo ID
  getOrderById: async (token, orderId) => {
    try {
      const response = await api.get(`/orders/${orderId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting order by ID:', error);
      throw error;
    }
  },

  // Cập nhật trạng thái order
  updateOrderStatus: async (token, orderId, status) => {
    try {
      const response = await api.put(`/orders/${orderId}/status`, {
        status: status
      }, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error updating order status:', error);
      throw error;
    }
  },

  // Xóa order
  deleteOrder: async (token, orderId) => {
    try {
      const response = await api.delete(`/orders/${orderId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error deleting order:', error);
      throw error;
    }
  },

  // Lấy thống kê orders
  getOrderStats: async (token, timeRange = 'all') => {
    try {
      const response = await api.get('/orders/statistics', {
        headers: getAuthHeaders(token),
        params: { timeRange }
      });
      return response;
    } catch (error) {
      console.error('Error getting order statistics:', error);
      throw error;
    }
  },

  // Lọc orders theo nhiều tiêu chí
  filterOrders: async (token, filters = {}) => {
    try {
      const response = await api.get('/orders/filter', {
        headers: getAuthHeaders(token),
        params: filters
      });
      return response;
    } catch (error) {
      console.error('Error filtering orders:', error);
      throw error;
    }
  },

  // Design Case API functions
  // Tạo design case mới
  createDesignCase: async (token, caseData) => {
    try {
      const response = await api.post('/design-cases', caseData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error creating design case:', error);
      throw error;
    }
  },

  // Kiểm tra design case đã tồn tại
  checkExistingDesignCase: async (token, orderId, productIds) => {
    try {
      const response = await api.get('/design-cases/check', {
        headers: getAuthHeaders(token),
        params: { order_id: orderId, product_ids: productIds.join(',') }
      });
      return response;
    } catch (error) {
      console.error('Error checking existing design case:', error);
      throw error;
    }
  },

  // Lấy danh sách design cases
  getDesignCases: async (token, params = {}) => {
    try {
      const response = await api.get('/design-cases', {
        headers: getAuthHeaders(token),
        params
      });
      return response;
    } catch (error) {
      console.error('Error getting design cases:', error);
      throw error;
    }
  },

  // Lấy chi tiết design case
  getDesignCaseById: async (token, caseId) => {
    try {
      const response = await api.get(`/design-cases/${caseId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting design case by ID:', error);
      throw error;
    }
  },

  // Cập nhật design case
  updateDesignCase: async (token, caseId, caseData) => {
    try {
      const response = await api.put(`/design-cases/${caseId}`, caseData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error updating design case:', error);
      throw error;
    }
  },

  // Xóa design case
  deleteDesignCase: async (token, caseId) => {
    try {
      const response = await api.delete(`/design-cases/${caseId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error deleting design case:', error);
      throw error;
    }
  },

  // Export orders
  exportOrders: async (token, exportData) => {
    try {
      const response = await api.post('/orders/export', exportData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error exporting orders:', error);
      throw error;
    }
  },

  // Lấy orders theo store
  getOrdersByStore: async (token, storeName) => {
    try {
      const response = await api.get(`/orders/store/${storeName}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting orders by store:', error);
      throw error;
    }
  },

  // Lấy orders theo seller
  getOrdersBySeller: async (token, sellerEmail) => {
    try {
      const response = await api.get(`/orders/seller/${sellerEmail}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting orders by seller:', error);
      throw error;
    }
  },

  // Bulk update orders
  bulkUpdateOrders: async (token, orderIds, updateData) => {
    try {
      const response = await api.put('/orders/bulk-update', {
        orderIds,
        updateData
      }, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error bulk updating orders:', error);
      throw error;
    }
  }
};

export default adminOrderApi; 
